'use client'
/* eslint-disable react/jsx-no-literals */
import React, { useEffect, useState } from 'react'
import formatDataOfPage from '../../lib/formatDataOfPage'
import Main from '../../themes/common/Main'
import { useSelector } from 'react-redux'
import {
  getProducts,
  getSearchResults,
} from '../../repositories/productRepository'

async function fetchSearchPageData(query, options) {
  const params = query
  const dataSearch = {
    params,
  }

  const productData = {
    params: {
      ...query,
    },
  }

  const [layoutResponse, productResponse] = await Promise.all([
    getSearchResults(dataSearch, options),
    (query?.filter || query?.sorting) && getProducts(productData, options),
  ])

  const pageData = layoutResponse || {}
  let initialProductsData = {}
  let layoutResponseFilter = {}
  if (layoutResponse?.layouts?.length > 0) {
    const productCollectionLayout = layoutResponse?.layouts?.find(
      (layout) => layout.name === 'ProductCollection'
    )

    const collection = productCollectionLayout?.value?.collection

    if (collection) {
      layoutResponseFilter = collection.filters || {}
      initialProductsData = collection
    }
  }
  const collectionData =
    query?.filter || query?.sorting ? productResponse : initialProductsData
  pageData.layouts = (pageData.layouts || []).map((layout) => {
    if (layout.name === 'ProductCollection') {
      return {
        ...layout,
        value: {
          ...layout.value,
          collection: {
            ...collectionData,
            filters: layoutResponseFilter,
          },
        },
      }
    }
    return layout
  })

  pageData.entity = {
    slug: params.q,
    name: 'Search results',
  }

  pageData.layouts = (pageData.layouts || []).map((layout) => {
    return {
      ...layout,
      data: { ...layout.data, layoutType: 'GRID', loadMoreType: 'INFINITE' },
    }
  })

  return pageData
}

export default function SearchPage({ params, searchParams }) {
  const [pageResponse, setPageResponse] = useState(null)

  const { organizationData, address } = useSelector((state) => ({
    organizationData: state.commonData.organizationData,
    address: state.address.address,
  }))

  const websiteTheme = organizationData?.theme?.name
  const isMarketPlace = organizationData?.config?.website?.isMarketPlace
  const orgName = organizationData?.name
  const urlParams = searchParams || {}
  const storeId =
    urlParams?.storeId || address?.storeId || organizationData?.defaultStoreId

  useEffect(() => {
    const loadPageData = async () => {
      try {
        const data = { storeId, isMarketPlace }
        const page = await fetchSearchPageData(urlParams, data, websiteTheme)
        const filteredResponse = {
          name: page?.name,
          showFilter: page?.showFilter,
          entity: page?.entity,
          pageId: page?.pageId,
          layouts: formatDataOfPage(page?.layouts),
        }
        setPageResponse(filteredResponse)
        document.title = `${orgName || 'Search'} : Search`
      } catch (error) {
        console.error('Error fetching search page data:', error)
      }
    }

    if (storeId && websiteTheme) {
      loadPageData()
    }
  }, [storeId, websiteTheme, isMarketPlace, orgName, searchParams])

  if (!pageResponse) return null

  return <Main pageData={pageResponse} websiteTheme={websiteTheme} />
}
